import { emptyApi } from '@/app/store/api/emptyApi';
import {
  ClientTelegramAuthControllerLoginApiResponse,
  ClientTokenAuthControllerRefreshApiResponse,
  ClientTokenAuthControllerLogoutApiResponse,
  ClientProfileControllerGetProfileApiResponse,
  ClientTelegramAuthControllerLoginApiArg,
  ClientProfileControllerGetProfileApiArg,
  ClientTokenAuthControllerRefreshApiArg,
  ClientTokenAuthControllerLogoutApiArg,
  ClientOAuthControllerStartApiResponse,
  ClientOAuthControllerStartApiArg,
  ClientOAuthControllerCallbackApiResponse,
  ClientOAuthControllerCallbackApiArg,
  ClientProfileControllerUpdateProfileApiResponse,
  ClientProfileControllerUpdateProfileApiArg,
  ClientStartAppControllerHandleApiResponse,
  ClientStartAppControllerHandleApiArg,
  ClientMagicAuthControllerRequestApiResponse,
  ClientMagicAuthControllerRequestApiArg,
  ClientMagicAuthControllerVerifyApiResponse,
  ClientMagicAuthControllerVerifyApiArg,
  EmailVerificationControllerRequestApiResponse,
  EmailVerificationControllerRequestApiArg,
  EmailVerificationControllerVerifyApiResponse,
  EmailVerificationControllerVerifyApiArg,
} from '@/app/store/api/restApi';

export const authApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    authTelegramLogin: build.mutation<
      ClientTelegramAuthControllerLoginApiResponse,
      ClientTelegramAuthControllerLoginApiArg
    >({
      query: ({ clientTelegramLoginDto }) => ({
        url: 'telegram/auth/login',
        method: 'POST',
        body: clientTelegramLoginDto,
      }),
    }),

    authClientProfile: build.query<
      ClientProfileControllerGetProfileApiResponse,
      ClientProfileControllerGetProfileApiArg
    >({
      query: () => ({ url: 'profile' }),
    }),

    updateClientProfile: build.mutation<
      ClientProfileControllerUpdateProfileApiResponse,
      ClientProfileControllerUpdateProfileApiArg
    >({
      query: ({ updateClientProfileDto }) => ({
        url: `profile`,
        method: 'PATCH',
        body: updateClientProfileDto,
      }),
    }),

    authRefresh: build.mutation<ClientTokenAuthControllerRefreshApiResponse, ClientTokenAuthControllerRefreshApiArg>({
      query: ({ refreshTokenDto }) => ({
        url: 'auth/refresh',
        method: 'POST',
        body: refreshTokenDto,
      }),
    }),

    authLogout: build.mutation<ClientTokenAuthControllerLogoutApiResponse, ClientTokenAuthControllerLogoutApiArg>({
      query: ({ refreshTokenDto }) => ({
        url: 'auth/logout',
        method: 'POST',
        body: refreshTokenDto,
      }),
    }),

    authOAuthStart: build.mutation<ClientOAuthControllerStartApiResponse, ClientOAuthControllerStartApiArg>({
      query: ({ provider, clientOAuthStartDto }) => ({
        url: `oauth/${provider}/start`,
        method: 'POST',
        body: clientOAuthStartDto,
      }),
    }),

    authOAuthCallback: build.mutation<ClientOAuthControllerCallbackApiResponse, ClientOAuthControllerCallbackApiArg>({
      query: ({ provider, clientOAuthCallbackDto }) => ({
        url: `oauth/${provider}/callback`,
        method: 'POST',
        body: clientOAuthCallbackDto,
      }),
    }),

    requestMagicAuth: build.mutation<
      ClientMagicAuthControllerRequestApiResponse,
      ClientMagicAuthControllerRequestApiArg
    >({
      query: ({ magicAuthRequestDto }) => ({
        url: 'auth/magic-link/request',
        method: 'POST',
        body: magicAuthRequestDto,
      }),
    }),

    verifyMagicAuth: build.mutation<ClientMagicAuthControllerVerifyApiResponse, ClientMagicAuthControllerVerifyApiArg>({
      query: ({ clientMagicAuthVerifyDto }) => ({
        url: 'auth/magic-link/verify',
        method: 'POST',
        body: clientMagicAuthVerifyDto,
      }),
    }),

    requestEmailVerification: build.mutation<
      EmailVerificationControllerRequestApiResponse,
      EmailVerificationControllerRequestApiArg
    >({
      query: ({ clientEmailVerificationRequestDto }) => ({
        url: 'profile/email-verification/request',
        method: 'POST',
        body: clientEmailVerificationRequestDto,
      }),
    }),

    verifyEmail: build.mutation<
      EmailVerificationControllerVerifyApiResponse,
      EmailVerificationControllerVerifyApiArg
    >({
      query: ({ clientEmailVerificationVerifyDto }) => ({
        url: 'profile/email-verification/verify',
        method: 'POST',
        body: clientEmailVerificationVerifyDto,
      }),
    }),

    clientStartAppHandle: build.mutation<
      ClientStartAppControllerHandleApiResponse,
      ClientStartAppControllerHandleApiArg
    >({
      query: ({ clientStartAppRequestDto }) => ({
        url: 'start-app/handle',
        method: 'POST',
        body: clientStartAppRequestDto,
      }),
    }),
  }),
});

export const {
  useAuthTelegramLoginMutation,
  useAuthClientProfileQuery,
  useLazyAuthClientProfileQuery,
  useAuthRefreshMutation,
  useAuthLogoutMutation,
  useAuthOAuthStartMutation,
  useAuthOAuthCallbackMutation,
  useRequestMagicAuthMutation,
  useVerifyMagicAuthMutation,
  useRequestEmailVerificationMutation,
  useVerifyEmailMutation,
  useUpdateClientProfileMutation,
  useClientStartAppHandleMutation,
} = authApi;
